export default "<div [ngClass]=\"bindingClass\" class=\"skeleton-box\" [style.height]=\"height\" [style.width]=\"width\"></div>"